<template>
  <div class="flex items-center gap-2 px-1">
    <Briefcase class="w-4 h-4 shrink-0 text-gray-400" />
    <span class="text-sm text-muted-foreground">Free job support until <strong class="font-medium text-gray-900">{{ formattedDate }}</strong></span>
  </div>
</template>

<script setup lang="ts">
import { Briefcase } from 'lucide-vue-next'

defineProps<{
  formattedDate: string
}>()
</script>
